import {Routes} from '@angular/router';
import {ErrorOverviewComponent} from './components/error-overview/error-overview.component';
import {ErrorMessageDetailComponent} from './components/error-message-detail/error-message-detail.component';
import {ExceptionDetailComponent} from './components/exception-detail/exception-detail.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {AuthGuard} from './guards/AuthGuard';
import {LogDetailComponent} from './components/log-detail/log-detail.component';
import {LogBookDetailComponent} from './components/log-book-detail/log-book-detail.component';
import {PermissionGuard} from './guards/PermissionGuard';
import {ForbiddenPageComponent} from './components/forbidden-page/forbidden-page.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';

export const routes: Routes = [
    {path: '', redirectTo: '/dashboard', pathMatch: 'full'},
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard, PermissionGuard],
    },
    {
        path: 'overview',
        component: ErrorOverviewComponent,
        canActivate: [AuthGuard, PermissionGuard],
    },
    {
        path: 'details',
        canActivate: [AuthGuard, PermissionGuard],
        children: [
            {
                path: 'message/:id',
                component: ErrorMessageDetailComponent,
            },
            {
                path: 'exception/:id',
                component: ExceptionDetailComponent,
            },
            {
                path: 'log/:id',
                component: LogDetailComponent,
            },
            {
                path: 'logbook/:id',
                component: LogBookDetailComponent,
            },
            {path: '', redirectTo: '/overview', pathMatch: 'full'},
        ],
    },
    {
        path: 'unauthorized',
        component: ForbiddenPageComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'not-found',
        component: PageNotFoundComponent,
    },
    {
        path: '**',
        redirectTo: '/not-found',
    },
];
